<template>
  <div class="attendee-select-modal">
    <modal-frame :showModalFlag="modalDisplay" :position="'heigh'" v-on:backdropClickEvent="selectionFinish">
      <div class="modal-header">
        <h1>通話参加者選択</h1>
        <div class="controll">
          <button class="select-finish-btn" @click="selectionFinish">選択完了</button>
        </div>
      </div>
      <div class="modal-body">
        <div 
          class="category-block"
          v-for="category in addressBook"
          :key="'sadrctg' + category.id"
          >
          <div class="category-title">
            <span class="category-name">{{ category.name }}</span>
          </div>
          <div class="entry-block"
            v-for="entry in category.address_entries"
            :key="'sadrent' + entry.id">
            <div class="entry-info-block" @click="toggleSelect(entry)">
              <span class="selected-flag">
                <custom-check-box
                  :type="'small'"
                  :active="isSelected(entry)"
                  :enabled="true"
                  />
              </span>
              <span class="entry-icon"><user-portrate :target="entry" :displaySize="'mini'"/></span>
              <span class="entry-name">{{ entry.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </modal-frame>
    <confirm-dialog
      :showDialog="confirmDialogVisible"
      :title="confirmDialogTitle"
      :message="confirmDialogMessage"
      :dialogType="confirmDialogType"
      v-on:negativeResultEvent="confirmFinishNegative"
      v-on:positiveResultEvent="confirmFinishPositive"
      />
  </div>
</template>

<script>
import {
  mapState,
  // mapActions, 
} from 'vuex'

import ModalFrame from '@/components/common/ModalFrame.vue'
import UserPortrate from '@/components/appView/common/UserPortrate.vue'
import CustomCheckBox from '@/components/common/CustomCheckBox.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

import ConfirmDialogControll from '@/mixin/ConfirmDialogControll'

// import * as DIALOG_TYPE from '@/assets/constants/dialogType.js'

export default {
  mixins: [ ConfirmDialogControll ],

  name: 'AttendeeSelectModal',

  components: {
    ModalFrame,
    UserPortrate,
    CustomCheckBox,
    ConfirmDialog,
  },

  props: {
    attendees: Array,
    modalDisplay: Boolean,
  },
  
  emits: [
    'selectFinishEvent',
  ],

  data () {
    return {
      selectedAttendees: []
    }
  },

  watch: {
    modalDisplay: { handler: 'initData', immediate: true },
  },

  computed: {
    ...mapState({
      // currentUser: state => state.user.currentUser,
      // currentDevice: state => state.user.currentDevice,
      // availableUsers: state => state.user.users,
      addressBook: state => state.addressBook.addressCategories,
    }),
  },

  methods: {
    // ...mapActions({
    //   fetchAddressBook: 'addressBook/fetch',
    // }),

    initData () {
      if (this.modalDisplay) {
        // this.fetchAddressBook()
        // 配列をクローン
        this.selectedAttendees = this.attendees.map(attendee => ({ ...attendee }))
      }
    },

    isSelected (attendee) {
      return this.selectedAttendees.some((sAttend) => sAttend.narrative_phone_id === attendee.narrative_phone_id)
    },

    toggleSelect (attendee) {
      let aIndex = this.selectedAttendees.findIndex(sAtt => sAtt.narrative_phone_id === attendee.narrative_phone_id)
      console.log(aIndex)
      if (aIndex >= 0) {
        if (this.selectedAttendees.length > 1) {
          this.selectedAttendees.splice(aIndex, 1)
        } else {
          this.showNotifyDialog('通話先件数', '通話先は最低1名指定してください')
        }
      } else {
        if (this.selectedAttendees.length < 8) {
          this.selectedAttendees.push(attendee)
        } else {
          this.showNotifyDialog('通話先件数', '通話先に指定できる人数は8名までです')
        }
      }
    },

    selectionFinish () {
      this.$emit('selectFinishEvent', this.selectedAttendees)
    },
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.attendee-select-modal {
  margin: 0;
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    padding-bottom: 0;
    h1 {
      margin: 0;
      font-size: 22pt;
      font-weight: normal;
    }
    .select-finish-btn {
      padding: 5px 8px 3px;
      border-radius: 5px;
      background-color: $normal-btn-color;
      border: 1px solid $normal-btn-color;
      color: $normal-btn-text-color;
      font-weight: bold;
    }
  }
  .modal-body {
    padding: 20px 10px;
    max-height: calc(100vh - 240px);
    overflow: auto;
    .category-block {
      .category-title {
        border-bottom: 1px solid #aaa;
      }
      .entry-block {
        margin: 20px 0;
        .entry-info-block {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .selected-flag {
            margin-right: 10px;
          }
          .entry-icon {
            margin-right: 10px;
          }
          .entry-name {
            font-size: 16pt;
          }
        }
      }
    }
  }
}
</style>